import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";export var breakpoints = _Object$freeze({
  sm: {
    up: '@media(min-width:641px)',
    down: '@media(max-width:640px)'
  },
  md: {
    up: '@media(min-width:769px)',
    down: '@media(max-width:768px)'
  },
  lg: {
    up: '@media(min-width:1025px)',
    down: '@media(max-width:1024px)'
  },
  xlg: {
    up: '@media(min-width:1281px)',
    down: '@media(max-width:1280px)'
  }
});

export var breakpointsValues = _Object$freeze({
  sm: 640,
  md: 768,
  lg: 1024,
  xlg: 1280
});
//# sourceMappingURL=breakpoints.js.map